var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpCircleOutline = function SvgHelpCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M8.125 7.708c.625-1.875 3.75-1.715 3.75.243 0 1.383-1.875 1.6-1.875 3.091m0 2.291v-.008M17.708 10a7.708 7.708 0 1 1-15.416 0 7.708 7.708 0 0 1 15.416 0m-7.5 3.333a.21.21 0 0 1-.208.209.209.209 0 0 1 0-.417c.115 0 .208.093.208.208"
  })));
};
export default SvgHelpCircleOutline;